import type { CheckInStatus } from '@empower-safety/shared-types';
import { cn } from '../lib/cn.js';

// Welfare check-in status pill. Mirrors StatusPill (alarms) but with the welfare
// vocabulary: active / completed / overdue / cancelled.

const labels: Record<CheckInStatus, string> = {
  active: 'Active',
  completed: 'Completed',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
};

const variants: Record<CheckInStatus, string> = {
  active: 'pill-info',
  completed: 'pill-resolved',
  overdue: 'pill-active',
  cancelled: 'pill-neutral',
};

export function CheckInStatusPill({
  status,
  className,
}: {
  status: CheckInStatus;
  className?: string;
}) {
  return <span className={cn('pill', variants[status], className)}>{labels[status]}</span>;
}
